import { Outlet } from 'react-router-dom';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';
import PrintBrandHeader from './PrintBrandHeader';
import AudiencePreviewBanner from './AudiencePreviewBanner';
import { useCmsPreviewBridge } from '../hooks/useCmsPreviewBridge';
import { usePreviewAudience } from '../hooks/usePreviewAudience';

export default function PublicLayout() {
  useCmsPreviewBridge();
  // Lot 335 · Bloc 1 — bandeau « mode aperçu audience » global (admin-only,
  // activé par ?_preview=public|investor|sponsor dans l'URL).
  const { audience, isPreviewing } = usePreviewAudience();
  // PHASE 8 B0 — surface publique dédiée `public-brand` : sortie du scope
  // CSS `v22-*` (portails internes) qui écrasait la typographie éditoriale
  // (Cormorant/Cinzel) en Manrope !important. Voir AUDIT_APEX_PHASE8_PUBLIC.md §1.
  return (
    <div className="min-h-screen flex flex-col" data-surface="public-brand">
      {isPreviewing && <AudiencePreviewBanner audience={audience} />}
      {/* LOT Public Design B — PrintBrandHeader global injecté ICI pour
         couvrir TOUTES les pages publiques (about, how-it-works, contact,
         login, request-access, avertissement-risques, etc.) en plus de la
         HomePage. Le composant est masqué en écran (`.wm-print-only`) et
         visible uniquement en print/PDF (page 1 de chaque page publique). */}
      <PrintBrandHeader />
      <PublicHeader />
      <main className={`flex-1 pt-[73px] ${isPreviewing ? 'pt-[115px]' : ''}`}>
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  );
}
